//This tooltip is added hard coded in the table headcells
export const headCells = [
    {id: 'idLotto', label: 'ID lotto', width: "15%", tooltipLabel: "In caso di cambio formato con distribuzione digitale contestuale puoi verificare l’esito invio email utilizzando come filtro l’ID lotto."},
    {id: 'numeroDiTelefono', label: 'Numero di telefono', width: "15%"},
    {id: 'nuovoSeriale', label: 'Nuovo seriale', width: "20%"},
    {id: 'dataInvioRichiesta', label: 'Data invio richiesta', width: "15%"},
    {id: 'esitoCambioFormato', label: 'Esito cambio formato', width: "16%"},
    {id: 'causaleKo', label: 'Causale KO', width: "19%"},
];